import axios from "axios";

// export default axios.create({
//   baseURL: "https://api.api-apple.com/api",
// });

export default axios.create({
  baseURL: "https://api.tafaseelapp.com/api",
});
